import { StyledIcon } from './SocialMediaLink.styled'

export const SocialMediaLink = ({ href, Icon }: { href: string; Icon: React.ElementType }) => {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      <StyledIcon as={Icon} />
    </a>
  )
}
